// utils.js

import store from "@/store/store";

// const supportedLanguages = ['en', 'zh', 'de', 'it', 'fr', 'ja'];//计划中拓竹地区列表需要支持的语言列表
// const supportedLanguages = ['ar','de','en','es','fr','he','it','ja','ko','pt','ru','tr', 'zh'];//起迪手机app支持的语言
const supportedLanguages = ['ar', 'cs', 'de', 'en', 'es', 'fr', 'he', 'hu', 'it', 'ja', 'ko', 'nl', 'pt', 'pt_BR', 'ru', 'sv', 'tr', 'uk', 'zh', 'zh_tw'];//软件专属的语言
const defaultLang = 'en';


//对于语言的格式化处理 比如说zh-HK这种 处理为zh
export function formatLanguage(lang) {
    if (!lang){
        return ''
    }
    // 处理中文语言设置
    if (lang.includes('zh-CN')) {
        lang = 'zh';
    } else if (lang.includes('zh-TW') || lang.includes('zh_tw')) {
        lang = 'zh_tw';
    } else if (lang.includes('zh')) {
        lang = 'zh';
    }
    // 检查是否支持该语言，否则使用默认语言
    if (!supportedLanguages.includes(lang)) {
        lang = defaultLang;
    }
    // 返回设置好的语言
    return lang;
}


//初始化获取本地语言
export function initializeLanguage() {
    // 从 localStorage 获取语言设置
    let localLang = localStorage.getItem('locale') || navigator.language || navigator.userLanguage || defaultLang;
    localLang = formatLanguage(localLang);
    // 返回设置好的语言
    return localLang;
}

//设置语言
export function setLanguage(lang) {
    lang = formatLanguage(lang);
    store.commit('setLanguage', lang); // 设置 Vuex 中的语言
    localStorage.setItem('locale', lang); // 设置 localStorage 中的语言
    // 返回设置好的语言
    return lang;
}



// WEBPACK FOOTER //
// ./src/utils/utils.js